export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-500/5 via-transparent to-accent-500/5"></div>
        <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-primary-500/3 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-0 w-[400px] h-[400px] bg-accent-500/3 rounded-full blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-4">
              🔥 今日必看
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
              暗网吃瓜
              <span className="block text-primary-400 mt-1">
                黑料爆料 · 隐秘八卦 · 真实吃瓜
              </span>
            </h1>

            <p className="mt-3 text-lg md:text-xl text-accent-400 font-heading">
              全网最敢说的吃瓜社区，每天更新最新爆料
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              暗网吃瓜致力于打造最真实、最及时的娱乐八卦与黑料爆料聚合平台。
              我们汇聚全网最劲爆的内幕消息、独家深扒和第一手吃瓜资讯，
              覆盖娱乐圈、网红圈、社会热点等多个领域。
              每日更新新鲜爆料，匿名投稿安全无忧，
              让每一位吃瓜群众都能第一时间掌握全网最热话题。
              当前热门：顶流塌房内幕、综艺剧本流出、网红翻车实锤持续追踪中。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                <span className="text-sm text-foreground-500">每日更新 <strong className="text-foreground-800">200+</strong> 条爆料</span>
              </div>
              <span className="text-foreground-300 hidden sm:inline">|</span>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm text-foreground-500">覆盖 <strong className="text-foreground-800">50+</strong> 话题领域</span>
              </div>
              <span className="text-foreground-300 hidden sm:inline">|</span>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                <span className="text-sm text-foreground-500">匿名投稿 <strong className="text-foreground-800">安全无忧</strong></span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-all whitespace-nowrap text-sm"
              >
                立即吃瓜
                <i className="ri-arrow-right-down-line"></i>
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-500/50 text-foreground-600 hover:text-primary-400 font-medium rounded-md transition-all whitespace-nowrap text-sm"
              >
                加入爆料群
                <i className="ri-group-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden border border-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20digital%20landscape%20with%20glowing%20crimson%20red%20neon%20accents%2C%20abstract%20encrypted%20data%20streams%20flowing%20through%20darkness%2C%20cyberpunk%20aesthetic%20with%20subtle%20tech%20elements%2C%20deep%20shadows%20with%20warm%20highlights%2C%20dramatic%20atmospheric%20composition%2C%20dark%20background%20with%20mysterious%20vibe%2C%20digital%20art%20style%2C%20editorial%20quality&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="暗网吃瓜 - 黑料爆料平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#updates" className="text-foreground-400 hover:text-primary-400 transition-colors">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}